import { render, staticRenderFns } from "./header.vue?vue&type=template&id=17dc4350&scoped=true&"
import script from "./header.vue?vue&type=script&lang=ts&"
export * from "./header.vue?vue&type=script&lang=ts&"
import style0 from "./header.vue?vue&type=style&index=0&id=17dc4350&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dc4350",
  null
  
)

export default component.exports